/**
 * `round F2`, the founder's reading of the pairs: **the equipment suggestions
 * come from the api, and this file holds none of them.**
 *
 * The same rule as `photo-views.ts` and for the same first reason: six French
 * words in a screen is what `hakili/no-french-outside-catalogue` refuses, and
 * the `fr-ML` catalogue is not their home either, because they are not copy , a
 * translator changing « Climatisation » would change a value that goes into
 * `catalog.vehicles.equipment` as typed.
 *
 * **They differ from the views in what they OBLIGE, and the difference matters
 * more than the resemblance.** A view name is a closed vocabulary the upload
 * door compares and refuses. These are SUGGESTIONS: one tap instead of one
 * typing, for the six a Bamako forecourt sells most. A dealer may type anything
 * else and the door takes it. So the panel offers them and never limits itself
 * to them.
 *
 * The two bounds travel with them because they are the api's rule: a screen
 * that held its own twelve and forty would be a second copy of a number the
 * database enforces, and the day one moved the other would not.
 */

/** What `GET /api/v1/reference/equipment` answers. */
export interface EquipmentReference {
  /** The common six, offered as chips. Never a closed set. */
  readonly suggested: readonly string[];
  /** At most this many entries on one car. */
  readonly maxEntries: number;
  /** At most this many characters in one entry. */
  readonly maxLength: number;
}

/**
 * What a panel holds before the door has answered.
 *
 * No suggestions, and bounds of zero, deliberately: a panel that guessed twelve
 * and forty would enforce numbers it had invented, and for one paint that is
 * indistinguishable from enforcing the api's. Zero offers nothing and refuses
 * nothing , the field is simply not ready yet, which is what it is.
 */
export const NO_EQUIPMENT: EquipmentReference = { suggested: [], maxEntries: 0, maxLength: 0 };
